import React from 'react';
import { trackCtaClick } from '../../../utils/gtm';

const ROWS = [
  { label: 'People on your books', inHouse: '1', us: '3 (accountant, reviewer, manager)' },
  { label: 'Visa, insurance, leave', inHouse: 'You pay', us: 'Included' },
  { label: 'Cover if they leave', inHouse: 'Start again', us: 'Team keeps the file' },
  { label: 'Monthly cost', inHouse: 'Salary + overheads', us: 'One fixed fee' },
];

const ArchitectureSection = ({ onOpenModal }) => (
  <section className="bk-arch" id="architecture" data-screen-label="Outsourced Accounting">
    <div className="bk-container bk-arch-grid">
      <div className="bk-arch-copy">
        <span className="bk-eyebrow bk-eyebrow--ink">Outsourced accounting in Dubai</span>
        <h2 className="bk-arch-title">A full accounting team instead of one in-house hire.</h2>
        <p className="bk-arch-desc">
          Outsourcing your bookkeeping in Dubai replaces salary, visa, insurance and leave cover with a fixed
          monthly fee, and adds a second reviewer an in-house hire can't give you.
        </p>
        <button
          type="button"
          className="bk-btn bk-btn--orange bk-arch-cta gtm-cta-btn"
          data-gtm-id="architecture-get-quote"
          id="architectureQuoteBtn"
          onClick={() => {
            trackCtaClick('architecture_get_quote');
            onOpenModal();
          }}
        >
          Get my fixed quote →
        </button>
      </div>

      <div className="bk-arch-table-wrap">
        <table className="bk-arch-table">
          <caption className="bk-visually-hidden">In-house accountant compared with Standard Auditors</caption>
          <thead>
            <tr>
              <td aria-hidden="true" />
              <th scope="col">In-house accountant</th>
              <th scope="col" className="is-us">Standard Auditors</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row) => (
              <tr key={row.label}>
                <th scope="row">{row.label}</th>
                <td>{row.inHouse}</td>
                <td className="is-us">{row.us}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);

export default ArchitectureSection;
